module.exports = __webpack_public_path__ + "img/safe_02.e44f2488.png";